module.exports = __webpack_public_path__ + "img/grayclose.0d08ab3e.svg";